export default function splitCommaSeparatedKeys(keys?: string): string[] {
  return keys?.split(',').filter(Boolean) ?? [];
}
